import Dexie, { liveQuery } from 'dexie';

const db = new Dexie('MyStockDB');

db.version(8).stores({
    stocks: '++id, kod, ambalaj',
    caris: '++guid,kod,unvan'
});
export { liveQuery };
export default db;


// WEBPACK FOOTER //
// ./src/db.js